export default "__VITE_ASSET__D5bVyLBr__"